import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { ProfileMoleculeReatom } from "../store/index.reatom"

export const useActivityItemsReatom = () => {
  const { activityQueryParamsAtom } = useMolecule(ProfileMoleculeReatom)
  const queryParams = activityQueryParamsAtom()
  const activityQuery = useSuspenseInfiniteQuery(queryParams)

  const queryResult = useMemo(
    () => ({
      ...activityQuery,
      pages: activityQuery.data.pages.map((page) => ({
        items: page.activities,
      })),
    }),
    [activityQuery],
  )

  return useInfiniteTableItems(queryResult)
}
